import { CSSProperties } from 'react';

import { Flex } from '@revenuemarket/cds';
import { Colors, typographyStyle } from '@revenuemarket/design';
import { Typography } from 'antd';

const InfoItem: React.FC<{
  title: React.ReactNode;
  description?: React.ReactNode;
  titleStyle?: CSSProperties;
}> = ({ title, description, titleStyle }) => {
  return (
    <Flex
      style={{
        width: '100%',
      }}
    >
      <Typography.Text
        style={{
          width: 120,
          ...typographyStyle['14_400'],
          color: Colors.gray600,
          display: 'flex',
          alignItems: 'center',
          flexShrink: 0,
          ...titleStyle,
        }}
      >
        {title}
      </Typography.Text>
      <Typography.Text style={{ ...typographyStyle['14_400'], color: Colors.gray900, flexGrow: 1 }}>
        {description}
      </Typography.Text>
    </Flex>
  );
};

export default InfoItem;
